import { ApiResponse, CustomQueryResponse } from "../../../model/common/apiResponse";
import { axiosService, ServiceEndPoint } from "../../../Services/common/Axios.service";
import { lookUpService } from "../../../Services/common/lookup.service";
import { ASN, CustomASN } from "../model/asnOverview.model";

const SERVICE_URL=ServiceEndPoint.inbound_service;

export async function fetchAsnData(page?: number,payload?:any): Promise<ApiResponse<CustomQueryResponse<any>>> {
       const response = await axiosService.post(`${SERVICE_URL}inbound-shipments/query`,payload);
       return response.data;
}
export function recordCounts(status: string[],searchTerm:string,conditions:any,search_columns:any) {
    return {
      columns: [
        {
          data: "inbound_shipment.id",
          func: "count",
          as: "asn_count"
        }
      ],
      conditions: [ ...conditions,
        ["inbound_shipment.status", "in", status]
      ],
      search_columns:search_columns,
      "search": searchTerm,
      
      limit: -1
    }
  }
export async function fetchStatusWiseCounts(statuses:string[],searchTerm:string,conditions:any,search_columns:any): Promise<ApiResponse<any[]>> {
    const responses = await Promise.all(
        statuses.map(status => 
            axiosService.post(`${SERVICE_URL}inbound-shipments/query`, recordCounts([status],searchTerm,conditions,search_columns))
        )
    );
    const result = responses.reduce((acc: any, response, index) => {
        acc[statuses[index]] = response.data?.data?.results[0].asn_count || 0;
        return acc;
    }, {});
    return { data: result };
}

export async function getAsnDetails(id?:string): Promise<ApiResponse<ASN>> {
    const response = await axiosService.get(`${SERVICE_URL}inbound-shipments/${id}`);
    return response.data;
}
export async function submitASNForm(payload:any): Promise<ApiResponse<any>> {
    const response = await axiosService.post(`${SERVICE_URL}inbound-shipments`,payload);
    return response.data;
}

export async function updateASNForm(payload:any,id?:string): Promise<ApiResponse<any>> {
  const response = await axiosService.put(`${SERVICE_URL}inbound-shipments/${id}`,payload);
  return response.data;
}

export async function deleteLineItem(asn_id:number, line_id: number): Promise<ApiResponse<any>> {
  const response = await axiosService.delete(`${SERVICE_URL}inbound-shipments/${asn_id}/line/${line_id}`);
  return response.data;
}
export async function clientLookup(): Promise<ApiResponse<any>> {
  const response = await lookUpService.clientLookup();
  return response.data;
}